import { Icon, Typography } from '@fox/atoms';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { useComponentStyleContext } from '../component-style-context';
import { MenuItem } from '../MegaMenu/contracts';
import { PAGE_TYPES } from '../page-types';
import { BurgerButtons } from './burger-buttons';
import { ButtonInputModel, HambugerMenuProps, HEADER_LINKS_ID, LoginStatusButtonInputModel, NAV_SEPARATOR } from './contracts';
import { HeaderLink } from './header-link';

const BurgerWrapper = styled.div<{ $isActive: boolean }>`
	width: 60px;
	height: 45px;
	position: relative;
	-webkit-transform: rotate(0deg);
	-moz-transform: rotate(0deg);
	-o-transform: rotate(0deg);
	transform: rotate(0deg);
	-webkit-transition: 0.5s ease-in-out;
	-moz-transition: 0.5s ease-in-out;
	-o-transition: 0.5s ease-in-out;
	transition: 0.5s ease-in-out;
	cursor: pointer;
	transform: scale(0.5);

	span {
		display: block;
		position: absolute;
		height: 5px;
		width: 100%;
		border-radius: 9px;
		opacity: 1;
		left: 0;
		-webkit-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
		-webkit-transition: 0.25s ease-in-out;
		-moz-transition: 0.25s ease-in-out;
		-o-transition: 0.25s ease-in-out;
		transition: 0.25s ease-in-out;
	}
	span:nth-child(1) {
		top: 0px;
		-webkit-transform-origin: left center;
		-moz-transform-origin: left center;
		-o-transform-origin: left center;
		transform-origin: left center;
	}

	span:nth-child(2) {
		top: 18px;
		-webkit-transform-origin: left center;
		-moz-transform-origin: left center;
		-o-transform-origin: left center;
		transform-origin: left center;
	}

	span:nth-child(3) {
		top: 36px;
		-webkit-transform-origin: left center;
		-moz-transform-origin: left center;
		-o-transform-origin: left center;
		transform-origin: left center;
	}

	${props =>
		props.$isActive
			? `span:nth-child(1) {
                -webkit-transform: rotate(45deg);
                -moz-transform: rotate(45deg);
                -o-transform: rotate(45deg);
                transform: rotate(45deg);
                top: -3px;
                left: 8px;
            }

            span:nth-child(2) {
                    width: 0%;
                    opacity: 0;
                }

            span:nth-child(3) {
                    -webkit-transform: rotate(-45deg);
                    -moz-transform: rotate(-45deg);
                    -o-transform: rotate(-45deg);
                    transform: rotate(-45deg);
                    top: 39px;
                    left: 8px;
                }`
			: ''}
`;

const HeaderLinkWrapper = styled.div<{ $isActive: boolean }>`
	transition: all 0.4s cubic-bezier(0, 0, 0.2, 1);
	overflow: hidden;
	${props => {
		return props.$isActive
			? `
            max-height: 10000px;
            opacity: 1;
        `
			: `
            max-height: 0px;
            opacity: 0;
        `;
	}}
	z-index: 2;
	position: fixed;
	width: 100%;
	height: 100%;
	overflow-y: scroll;
`;

const findMenuItem = (menuItemName, menuItems: MenuItem[]) => {
	for (let i = 0; i < menuItems.length; i++) {
		const item = menuItems[i];

		for (const key of Object.keys(item)) {
			if (Array.isArray(item[key])) {
				const res = findMenuItem(menuItemName, item[key]);
				if (res) return res;
			} else if (item[key] === menuItemName) {
				return item;
			}
		}
	}
};

export function MobileHeaderLinks({
	isActive,
	menuItems,
	currentUrl,
	headerButtons,
	loginStatus
}: {
	isActive: boolean;
	menuItems: MenuItem[];
	currentUrl: string;
	headerButtons: ButtonInputModel[];
	loginStatus: LoginStatusButtonInputModel[];
}) {
	const [navLocation, setNavLocation] = useState<string>('0');
	const currentNavArray = navLocation.split(NAV_SEPARATOR);
	const { linkHoverColour, linkHoverUnderline } = useComponentStyleContext();
	let currentMenuItem: MenuItem = undefined;
	for (let i = 1; i < currentNavArray.length; i++) {
		currentMenuItem = findMenuItem(currentNavArray[i], menuItems);
	}
	return (
		<HeaderLinkWrapper className="burger-menu-links" $isActive={isActive}>
			{headerButtons?.length > 0 || loginStatus?.length > 0 ? (
				<BurgerButtons headerButtons={headerButtons} loginStatus={loginStatus} />
			) : null}
			{navLocation !== '0' ? (
				<>
					<div
						className="navbar-font-color-style"
						onClick={() => {
							const locationArray = navLocation.split(NAV_SEPARATOR);
							locationArray.pop();
							setNavLocation(locationArray.join(NAV_SEPARATOR));
							window.scrollTo({ top: 0, behavior: 'smooth' });
						}}
						style={{
							padding: '1rem 1.2rem',
							display: 'flex',
							justifyContent: 'flex-start',
							alignItems: 'center',
							borderTop: '1px solid',
							borderBottom: '1px solid',
							marginBottom: '0.5rem'
						}}
					>
						<Icon iconName="ArrowBackIosNew" />
						<Typography style={{ marginLeft: '1rem' }}>Go back</Typography>
					</div>

					{currentMenuItem !== undefined && currentMenuItem.type !== PAGE_TYPES.PAGE_FOLDER ? (
						<a
							className="navbar-font-color-style"
							href={currentMenuItem.url}
							target={currentMenuItem.openInNewTab ? '_blank' : '_self'}
						>
							<div className="current-menu-item" style={{ padding: '1rem 1.5rem', borderLeft: '5px solid' }}>
								<Typography
									style={{ ...(currentMenuItem.url === currentUrl ? { ...linkHoverColour, ...linkHoverUnderline } : {}) }}
								>
									{currentMenuItem.name}
								</Typography>
							</div>
						</a>
					) : currentMenuItem !== undefined && currentMenuItem.type === PAGE_TYPES.PAGE_FOLDER ? (
						<div
							className="current-menu-item navbar-font-color-style"
							style={{ padding: '1rem 1.5rem', borderLeft: '5px solid' }}
						>
							<Typography
								style={{
									...(currentMenuItem.url === currentUrl ? { ...linkHoverColour, ...linkHoverUnderline } : {}),
									opacity: '0.5'
								}}
							>
								{currentMenuItem.name}
							</Typography>
						</div>
					) : null}
				</>
			) : null}
			{menuItems?.map((menuItem, i) => {
				return (
					<HeaderLink
						key={`${menuItem.name}/0/${i}`}
						menuItem={menuItem}
						navLocation={navLocation}
						setNavLocation={setNavLocation}
						path="0"
						currentUrl={currentUrl}
					/>
				);
			})}
		</HeaderLinkWrapper>
	);
}

export function HamburgerMenu({ currentUrl, menuItems, headerButtons, loginStatus }: HambugerMenuProps) {
	const [isActive, setIsActive] = useState<boolean>(false);
	const element = document.getElementById(HEADER_LINKS_ID);

	return (
		<>
			<BurgerWrapper
				onClick={() => {
					setIsActive(!isActive);
					document.body.style.overflowY = isActive ? 'visible' : 'hidden';
				}}
				$isActive={isActive}
			>
				<span className="burger-icon"></span>
				<span className="burger-icon"></span>
				<span className="burger-icon"></span>
			</BurgerWrapper>
			{createPortal(
				<MobileHeaderLinks
					isActive={isActive}
					menuItems={menuItems}
					currentUrl={currentUrl}
					headerButtons={headerButtons}
					loginStatus={loginStatus}
				/>,
				element
			)}
		</>
	);
}
